// Saved versions of a workflow, with restore.
import { useEffect, useState } from "react";
import { Button, Empty, Modal, Popconfirm, Spin } from "antd";
import { History } from "lucide-react";
import { toast } from "react-toastify";
import { getWorkflowVersions, restoreWorkflowVersion } from "../../../api/workflowServices";

const formatDate = (value) => new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });

const VersionsDialog = ({ open, onClose, workflow, canEdit, onRestored }) => {
  const [versions, setVersions] = useState(null);

  useEffect(() => {
    if (!open || !workflow._id) return;
    setVersions(null);
    getWorkflowVersions(workflow._id)
      .then((response) => setVersions(response.data))
      .catch(() => setVersions([]));
  }, [open, workflow._id, workflow.version]);

  const restore = async (version) => {
    try {
      await restoreWorkflowVersion(workflow._id, version);
      toast.success(`Restored version ${version}`);
      onRestored();
      onClose();
    } catch (error) {
      toast.error(error?.message || "Could not restore");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <span className="flex items-center gap-2">
          <History size={16} /> Version history
        </span>
      }
    >
      <div className="mb-2 rounded-md bg-blue-50 px-3 py-2 text-sm">
        Current: <strong>version {workflow.version}</strong>
      </div>
      {!versions ? (
        <div className="py-6 text-center">
          <Spin />
        </div>
      ) : versions.length === 0 ? (
        <Empty description="No earlier versions yet" />
      ) : (
        <div className="max-h-[50vh] divide-y overflow-y-auto">
          {versions.map((version) => (
            <div key={version.version} className="flex items-center justify-between py-2">
              <div>
                <div className="text-sm font-medium">
                  Version {version.version} · {version.name}
                </div>
                <div className="text-xs text-gray-500">
                  {formatDate(version.createdAt)}
                  {version.savedBy ? ` · ${version.savedBy.firstName} ${version.savedBy.lastName}` : ""}
                </div>
              </div>
              {canEdit && (
                <Popconfirm title={`Restore version ${version.version}?`} description="Your current version is kept in the history." onConfirm={() => restore(version.version)}>
                  <Button size="small">Restore</Button>
                </Popconfirm>
              )}
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default VersionsDialog;
